<script setup>
import WidgetPage from '@/components/WidgetPage.vue';
import ToastHost from '@/components/base/ToastHost.vue';

</script>

<template>
  <Suspense>
    <WidgetPage />
  </Suspense>
  <ToastHost />
</template>
